/**
 *
 * Created by vsuthar on 9/24/18 File TabPane
 * Project: App Portal ©PaloAlto Networks
 */
import React from 'react'
import classNames from 'classnames'
import { Tabs as AntTabs } from 'antd'
import './Tabs.scss'
const { TabPane } = AntTabs
const TabPanel = ({ className, ...restProps }) => {
  const props = {
    ...restProps,
    className: classNames(className, 'pan-tabs')
  }

  return (
    <TabPane {...props} />
  )
}
TabPanel.AntTabs = AntTabs
export default TabPanel
